import { Slot, router } from 'expo-router';
import React from 'react';

import { AuthContext, AuthInterface } from '@fhs-legacy/frontend/src/state/auth';

export default class AuthLayout extends React.Component {
  static contextType = AuthContext;

  private shouldRedirectToSupport = (location: string): boolean => {
    return location === 'PYPESTREAM' || location === '/support';
  };

  componentDidMount(): void {
    if ((this.context as AuthInterface).isAuthenticated) {
      if (router.canGoBack()) {
        if (this.shouldRedirectToSupport((this.context as AuthInterface).originLocation)) {
          router.replace('/support');
        } else {
          router.back();
        }
      } else {
        router.replace('/');
      }
    }
  }

  render() {
    return <Slot />;
  }
}
